<template>
  <div class="box">
    <div class="container">
      <div class="days row">
        <time-number :number="differences.days"></time-number> dni
      </div>
      <div class="time row">
        <time-number :number="differences.hours"></time-number>:<time-number :number="differences.minutes"></time-number>:<time-number :number="differences.seconds"></time-number>
      </div>
      <div class="start row">... in to je šele začetek &lt;3</div>
    </div>
  </div>
</template>

<script>
import TimeNumber from "./TimeNumber";
import moment from "moment";

export default {
  name: 'Countdown',
  components: {
    TimeNumber
  },
  props: ['end'],
  data () {
    return {
      differences: {
        days: 50,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
    }
  },
  methods: {
    calculateDiff() {
      const diff = moment.duration(moment().diff(this.end));
      this.differences.days = Math.floor(diff.asDays());
      this.differences.hours = this.pad(diff.hours());
      this.differences.minutes = this.pad(diff.minutes());
      this.differences.seconds = this.pad(diff.seconds());
    },
    pad(n, size = 2) {
      const combined = ('00' + n);
      return combined.substr(combined.length - size, size);
    }
  },
  mounted() {
    this.calculateDiff();
    setInterval(this.calculateDiff, 1000);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  text-align: center;
  border: 1px solid gray;
  border-radius: 10px;
  margin-bottom: 30px;
}

.days {
  font-size: 5rem;
  display: block;
}

.time {
  font-size: 3rem;
  display: block;
}

.start {
  display: block;
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/components/Countdown.vue